import { render, staticRenderFns } from "./SharedMailBaserSenders.vue?vue&type=template&id=e6eb46ec&scoped=true"
import script from "./SharedMailBaserSenders.vue?vue&type=script&lang=js"
export * from "./SharedMailBaserSenders.vue?vue&type=script&lang=js"
import style0 from "./SharedMailBaserSenders.vue?vue&type=style&index=0&id=e6eb46ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6eb46ec",
  null
  
)

export default component.exports